import React, { useEffect, useState } from "react";
import ImageCarousel from "../../../components/ImageCarousel";
import classes from "./index.module.css";
import { GrFormEdit } from "react-icons/gr";
import OtpInput from "react-otp-input";
import {
  GENERATE_FORGET_PASSWORD_OTP,
  VERIFY_MOBILE,
} from "../../../api-calls/api-urls";
import AppLogo from "../../../assets/images/mainLogo.png";
import { ValidatorForm } from "react-material-ui-form-validator";
import "../../../assets/css/style.css";
import {
  pageLoader,
} from "../../../Redux/actions/user-actions";
import "../../../assets/css/index.css";
import { Button, Card, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../api-calls/user-requests";
import { getLanguagedataFunction } from "../../../utilities/language";
import UpdateModal from "./updateModal";
import AlertBox from "../../../components/AlertBox";
import lineDraw from "../../../assets/images/Wizardmobile.png";
const Otp1 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  const [Otp, setOtp] = useState("");
  const [time, setTime] = useState(15);
  const regUser = JSON.parse(sessionStorage.getItem("CurrentUser"));

  useEffect(() => {
    if (showAlert) {
      const timeout = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // Change the duration (in milliseconds) as per your requirement

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showAlert]);

  const handleSubmit = async () => {
    const userEntry = {
      user_id: regUser._id,
      phone_otp: Otp,
    };
    try {
      dispatch(pageLoader(true));
      // eslint-disable-next-line unused-imports/no-unused-vars
      await api.post(VERIFY_MOBILE, userEntry);
      if (regUser.email) {
        navigate("/otp2", { replace: true });
      } else {
        navigate("/register-company");
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setShowAlert(true);
        setError(error.response.data.message);
      } else {
        // Handle other errors
        // ...
      }
    }
  };

  const [phone_otp, setPhone_Otp] = useState();
  const [moddleToggle, setModdleToggle] = useState(false);
  const ln = useSelector((state) => state.allUsers.language_json);
  const [disable, setDisable] = useState({
    name: ln ? `${ln.resend_in} ${time}${ln.seconds}` : null,
    state: true,
  });

  useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const handleOtp = async () => {
    const userEntry = {
      email: regUser.phone,
      user_id: regUser._id,
      user_type: regUser.user_type,
    };
    const { data } = await api.post(GENERATE_FORGET_PASSWORD_OTP, userEntry);
    //sessionStorage.setItem("otp", JSON.stringify(data));
    setPhone_Otp(data.phone_otp);
  };

  const handleResetClick = async () => {
    setOtp(null);
    handleOtp();
    setTime(15);
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevCount) => prevCount - 1);
      setDisable({
        name: ln ? `${ln.resend_in} ${time}${ln.seconds}` : null,
        state: true,
      });
    }, 1000);

    if (time === 0) {
      clearInterval(timer);
      setDisable({
        name: `${ln.resend_otp}`,
        state: false,
      });
    }

    return () => {
      clearInterval(timer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);
  // useEffect(() => {
  //   if (!localStorage.getItem("CurrentUser")) {
  //     navigate("/personal-details");
  //   }
  // }, []);
  useEffect(() => {
    if (regUser) {
      setPhone_Otp(regUser.phone_otp);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleOnchange = (e) => {
    const re = /^\d*$/;
    if (e === "" || re.test(e)) {
      setOtp(e);
    }
  };

  const closeModal = () => {
    setModdleToggle(false);
  };
  return (
    <div className={classes.maindivForlogin}>
      {ln ? (
        <Card className={classes.SelectLanguage_maindiv}>
          <div>
            <ImageCarousel />
          </div>
          <ValidatorForm useref="form" onSubmit={handleSubmit}>
            <Box sx={{ width: '100%' }}>
              <div style={{ padding: "3rem" }}>
                <div>
                  <Box component="span" className="logo-lg" sx={{ mb: 6 }}>
                    <img src={AppLogo} alt="" height="50" />
                  </Box>
                  <Box className="header1" sx={{ mt: 3 }}>
                    <img
                      src={lineDraw}
                      alt=""
                      className={classes.wizardImage}
                    />
                  </Box>
                  <Typography className={classes.loginHeading} sx={{ mt: 2 }}>
                    {ln.verify_otp}
                  </Typography>
                  <Typography className={classes.loginDescription} sx={{ mt: 3 }}>
                    {ln.enter_otp_mobile} <br />
                    <b className={classes.boldContainer}>
                      <span className={classes.mobileNumber}>
                        +91 {regUser.phone}
                      </span>{" "}
                      <span onClick={() => setModdleToggle(true)}>
                        <GrFormEdit />
                      </span>
                    </b>
                  </Typography>
                  {regUser ? (
                    <Typography>Your Phone OTP is: {phone_otp}</Typography>
                  ) : null}
                </div>

                <Box sx={{ mt: 3 }}>
                  <div className={`otp ${classes.OtpFeildsContainer}`}>
                    <OtpInput
                      value={Otp}
                      onChange={(e) => handleOnchange(e)}
                      numInputs={4}
                      renderInput={(props) => <input {...props} />}
                      isInputNum={true}
                    />
                  </div>
                  <Box sx={{ mt: 3 }}>
                    <Typography className={classes.login_form_lable} sx={{ mb: 0 }}>
                      {ln.didnt_recieve_otp}
                      <Button
                        disabled={disable.state}
                        className={`${classes.login_form_lable} ${classes.remember_input} ${classes.forgotbtn}`}
                        variant="text"
                        sx={{
                          "&.Mui-disabled": {
                            color: "#0000ff73 !important",
                          },
                        }}
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          border: "none",
                          textTransform: "none",
                        }}
                        onClick={() => handleResetClick()}
                      >
                        {disable.name}
                      </Button>
                    </Typography>
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    <Button
                      disabled={Otp && Otp?.length === 4 ? false : true}
                      variant="contained"
                      className={classes.commonbtn}
                      sx={{ width: '100%' }}
                      type="submit"
                    >
                      {ln.continue}
                    </Button>
                  </Box>
                </Box>
              </div>
            </Box>
          </ValidatorForm>
        </Card>
      ) : null}
      {moddleToggle && (
        <UpdateModal
          type={"number"}
          closeModal={closeModal}
          value={regUser.phone}
        />
      )}
      {showAlert && error && (
        <AlertBox type="error" message={error} stateName={setShowAlert} />
      )}
    </div>
  );
};

export default Otp1;
